import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { IMonitoredAreaRepository } from '../../domain/repositories/IMonitoredArea.repository'
import { IHttpGetMethod } from '../../../@shared/domain/interfaces/IHttpClient.interface'
import { MonitoredArea } from '../../domain/entities/MonitoredArea'
import { MonitoredAreaSchema } from './schemas/MonitoredArea.schema'

export class MonitoredAreaRepositoryApiAdapter implements IMonitoredAreaRepository {
	private _endpoint = '/v1/area-monitorada'

	constructor(private _httpClient: IHttpGetMethod) {}

	async getSetted(customerId: string): Promise<MonitoredArea[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-configuradas-vinculados-a-id-customer/${customerId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return MonitoredAreaSchema.array().parse(response.data)
	}

	async getUnsetted(customerId: string): Promise<MonitoredArea[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-nao-configuradas-vinculados-a-id-customer/${customerId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return MonitoredAreaSchema.array().parse(response.data)
	}
}
